import { SearchInput } from '../shared';
import { SortOrder, MeetingRoomSortType } from '../enums';

export class GetMeetingRoomsInput extends SearchInput<MeetingRoomSortType> {
    constructor() {
        super(MeetingRoomSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}